document.addEventListener('DOMContentLoaded', () => {
  const items = Array.from(document.querySelectorAll('[data-faq-item]'));
  if (items.length === 0) return;

  const DURATION = 300;
  const busy = new WeakSet();

  const closeItem = (item) => {
    if (busy.has(item)) return;
    busy.add(item);

    const answer = item.querySelector('[data-faq-answer]');
    const icon = item.querySelector('[data-faq-icon]');
    if (!answer) {
      busy.delete(item);
      return;
    }

    item.classList.remove('is-open');
    if (icon) icon.textContent = '+';

    answer.style.maxHeight = `${answer.scrollHeight}px`;
    answer.style.opacity = '1';

    requestAnimationFrame(() => {
      answer.style.maxHeight = '0px';
      answer.style.opacity = '0';
    });

    setTimeout(() => {
      answer.hidden = true;
      answer.style.maxHeight = '';
      answer.style.opacity = '';
      busy.delete(item);
    }, DURATION);
  };

  const openItem = (item) => {
    if (busy.has(item)) return;
    busy.add(item);

    const answer = item.querySelector('[data-faq-answer]');
    const icon = item.querySelector('[data-faq-icon]');
    if (!answer) {
      busy.delete(item);
      return;
    }

    answer.hidden = false;
    const targetHeight = answer.scrollHeight;
    answer.style.maxHeight = '0px';
    answer.style.opacity = '0';

    requestAnimationFrame(() => {
      answer.style.maxHeight = `${targetHeight}px`;
      answer.style.opacity = '1';
    });

    item.classList.add('is-open');
    if (icon) icon.textContent = '−';

    setTimeout(() => {
      answer.style.maxHeight = '';
      answer.style.opacity = '';
      busy.delete(item);
    }, DURATION);
  };

  items.forEach((item) => {
    const answer = item.querySelector('[data-faq-answer]');
    if (answer) {
      answer.hidden = true;
      answer.style.maxHeight = '';
      answer.style.opacity = '';
    }

    const toggle = item.querySelector('[data-faq-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const section = item.closest('section');
      const siblings = section ? Array.from(section.querySelectorAll('[data-faq-item]')) : [];

      siblings.forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains('is-open')) {
          closeItem(otherItem);
        }
      });

      if (item.classList.contains('is-open')) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  });
});
